var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Versicherte---Filter-eingeklappt",
    transform: "translate(-302.000000, -128.000000)",
    stroke: "var(--blue)",
    strokeWidth: 2,
    className: "toggle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(286.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-entry"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus-Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(15.500000, 15.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,8.5 L16.5,8.5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,8.5 L16.5,8.5",
    id: "Path",
    transform: "translate(8.500000, 8.500000) rotate(-270.000000) translate(-8.500000, -8.500000) "
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.3a01f48d.svg";
export { ForwardRef as ReactComponent };